import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRegion } from "../services/update-region";
import { toast } from "@/hooks/use-toast";
import { RegionFormData } from "../schema/region-schema";

export function useUpdateRegion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<RegionFormData> }) =>
      updateRegion(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["regions"] });
      toast({ title: "Success", description: "Region updated successfully" });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to update region",
        variant: "destructive",
      });
    },
  });
}
